import config from '../../settings/config'
import Step from '../Step'

export default class ALotOfMessages extends Step {
	constructor() {
		super(config.scenario.chapter3.steps.aLotOfMessages)
	}
}
